import { FC } from 'react'
import { AdditionalServicesInformation } from 'components/AdditionalServices'
import { UserProtectedRoute } from 'routes'

const AdditionalServicesInformationPage: FC = () => {
  return (
    <UserProtectedRoute>
      <AdditionalServicesInformation />
    </UserProtectedRoute>
  )
}

export default AdditionalServicesInformationPage
